/**
 * Normalize hyphens, en/em dashes, and their supported HTML entities to the requested dash.
 */
export function replaceDashes(str: string, dash: string = "–"): string {
  return str.replace(/[-–—]|&#45;|&#8211;|&#8212;|&mdash;|&ndash;/g, dash);
}

/**
 * Pass numeric inputs through unchanged or parse an integer prefix from text.
 * This is coercion, not validation: fractional numbers remain unchanged and text may yield NaN.
 */
export function ensureInt(x: string | number): number {
  if (typeof x === "number") {
    return x;
  }

  return parseInt(x);
}
